export const FIREBASE_API_KEY = "AIzaSyAh1jLjXBa9pMNQo34_HRtxl6JvKD8prvg"
export const FIREBASE_AUTH_DOMAIN = "sbi-sunat.firebaseapp.com"
export const FIREBASE_PROJECT_ID = "sbi-sunat"
export const FIREBASE_STORAGE_BUCKET = "sbi-sunat.appspot.com"
export const FIREBASE_MESSAGING_SENDER_ID = "294164177683"
export const FIREBASE_APP_ID = "1:294164177683:web:7ef5840b4342586cbb70e6"
